import jwtDecode from 'jwt-decode';

export default {
    initAuth(routeTo) {
        const tokens = this.getToken();
        
        if(tokens && tokens.idToken) {
            // Already authenticated, TODO: do we need to Re-Auth token
            let idToken = jwtDecode(tokens.idToken);
            if(idToken.identities) {
                return this.getConfig(true);
            }
            else {
                return this.getConfig(false);
            }
        }
        else {
            // SSO and Reset password use query.code
            const urlCode = routeTo.query && routeTo.query.code || false;
            // Confirm this is not a password reset request
            const re = new RegExp(/reset/);
            const match = re.exec(routeTo.path);
            const isSingleSignOn = urlCode && !(match && match.length);
            return this.getConfig(isSingleSignOn);
        }
    },
    getConfig(isSSO = false) {
        let config;

        if(isSSO) {
            let domain, env;
            switch(process.env.ENV_NAME.toLowerCase()) {
                case 'dev':
                    // To use local env, change to 'localhost:9999' and remove "s" from https within the oauth redirect parameters 
                    domain = 'dev.digitalclone.com';
                    env = 'dev';
                    break;
                case 'qa':
                    domain = 'stg.digitalclone.com';
                    env = 'stg';
                    break;
                case 'prod':
                    domain = 'digitalclone.com';
                    env = 'prod';
                    break;
            }

            config = { 
                Auth: {
                    region: process.env.REGION,
                    userPoolId: process.env.SAML_USER_POOL,
                    userPoolWebClientId: process.env.SAML_CLIENT_ID,
                    oauth: {
                        domain: `saml-dc-${env}.auth.us-east-1.amazoncognito.com`.toLowerCase(),
                        scope: ['openid'],
                        redirectSignIn: `https://${domain}/login/`.toLowerCase(),
                        redirectSignOut: `https://${domain}/`.toLowerCase(),
                        responseType: 'code' // or 'token', note that REFRESH token will only be generated when the responseType is code
                    }
                }
            }
        }
        else {
            config = {
                Auth: {
                    region: process.env.REGION,
                    userPoolId: process.env.USER_POOL_ID,
                    userPoolWebClientId: process.env.USER_POOL_WEB_CLIENT_ID,
                    identityPoolId: process.env.IDENTITY_POOL_ID
                }
            };
        }

        return config;
    },
    getToken() {
        const tokens = {};
        Object.keys(localStorage).forEach(k => {
            let keyArray = k.split('.');
            let lastIdx = keyArray.length - 1;
            let re = RegExp('.*Token');
            let match = re.exec(keyArray[lastIdx]);
            if(match) {
                tokens[keyArray[lastIdx]] = localStorage[k];
            }
        });
        return (Object.values(tokens)).length > 0 ? tokens : null;
    },
    isMFARequired(user) {
        if('attributes' in user) {
            if('custom:auth' in user['attributes']) {
                const customAuth = JSON.parse(user['attributes']['custom:auth']);
                if('requireMFA' in customAuth) {
                    return customAuth['requireMFA'];
                }
            }
        }
        return false;
    }
}



// WEBPACK FOOTER //
// ./src/util/user.js